<ul *adaptLoadingUntilFirstEmit="let locations of parentsOfLinks$">
    @for (location of locations; track location) {
        <li>
            <adapt-link-process-map [processMap]="location.processMap"></adapt-link-process-map>
            @if (location.parentProcessStep) {
                <adapt-process-step-card [processStep]="location.parentProcessStep"></adapt-process-step-card>
            }
        </li>
    }
</ul>
